import * as THREE from "three"
import { pinSpace } from "../../constants"

export default class Pin extends THREE.Object3D {
    constructor(scene, indexInRow, rowIndex) {
        super()
        this.scene = scene
        this.index = indexInRow + rowIndex
        this.mesh = new THREE.Mesh(new THREE.BoxBufferGeometry(1, 3, 1), new THREE.MeshBasicMaterial({ color: 0x2222ff }))
        this.mesh.position.set(indexInRow*pinSpace - rowIndex*pinSpace/2, 0, -rowIndex*pinSpace/2 - pinSpace)
        this.scene.add(this.mesh)
        // this.mesh.visible = false
    }

    init(scene) {
        this.scene = scene
    }

    update() {

    }
}

// const _instance = new Example()
// export default _instance